// extracted by mini-css-extract-plugin
export default {"container":"vP-z","title":"wP-z","link":"xP-z"};